import React, { Component } from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import ToggleInput from 'screens/components/basic/ToggleInput';

class PaymentInfo extends Component {
    constructor(props) {
        super(props);
        this.getPaymentOption = this.getPaymentOption.bind(this);
        this.state = {
            paymentDialog: false
        };
    }


    openPaymentDialog = () => {
        this.setState({ paymentDialog: true });
    }
    
    closePaymentDialog = () => {
        this.setState({ paymentDialog: false });
    }

    getPaymentOption = () => {
        return (
            [
                { 
                    gateway: "Email Money Transfer",
                    status: "Active",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.openPaymentDialog()}
                            />
                        </div>
                    ) 
                },
                { 
                    gateway: "Direct Bank Transfer",
                    status: "Inactive",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.openPaymentDialog()}
                            />
                        </div>
                    ) 
                },
                { 
                    gateway: "PayPal",
                    status: "Inactive",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.openPaymentDialog()}
                            />
                        </div>
                    ) 
                }
            ]
        );
    }

    render() {
        return (
                <div>
                    <CardSimple>
                        <h4 className="ml-1 mb-2 mt-3">PAYMENT OPTION</h4>
                        <GenericTable
                            className="table_center"
                            tableBodyClassName="table_center"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            selectable={true}
                            columns={LOOKUP.menu.admin.generalInfo.payment.tableColumns}
                            rows={this.getPaymentOption()}
                            stripedRows={true}
                        />
                    </CardSimple>  
                    <br />
                    <div className="row">
                        <div className="col-lg-12">
                            <Button name="buttonSave"
                                className="pull-right"
                                label={LOOKUP.menu.admin.coupon.controls.saveButton}
                                primary={true} />
                            <Button name="buttonCancel"
                                className="pull-right btn-space"
                                label={LOOKUP.common.cancel.text} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <DialogInput
                        title={LOOKUP.menu.admin.generalInfo.payment.title}
                        actions={[
                            <Button
                                key={1}
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label={LOOKUP.common.cancel.text}
                                onTouchTap={() => this.closePaymentDialog()} />,
                            <Button
                                key={2}
                                name="ConfirmButton"
                                label={LOOKUP.common.confirm.text}
                                primary={true} 
                                onTouchTap={() => this.closePaymentDialog()}
                        />]}
                        modal={true}
                        open={this.state.paymentDialog}>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <TextInput
                                    fullWidth={true}
                                    name="storeCity"
                                    floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.title.label}
                                    hintText={LOOKUP.menu.admin.generalInfo.labels.title.label}
                                    maxLength={20}/>
                            </div> {/* .col */}
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <TextInput
                                    fullWidth={true}
                                    name="storeState"
                                    floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.description.label}
                                    hintText={LOOKUP.menu.admin.generalInfo.labels.description.label}
                                    maxLength={20}/>
                            </div> {/* .col */}
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <TextInput
                                    fullWidth={true}
                                    name="storeCity"
                                    floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.instruction.label}
                                    hintText={LOOKUP.menu.admin.generalInfo.labels.instruction.label}
                                    maxLength={20}/>
                            </div> {/* .col */}
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <ToggleInput 
                                    className="payment_option_status"
                                    name="paymentOptionStatus"
                                    label={LOOKUP.menu.admin.generalInfo.paymentOptionStatus.label} />
                            </div> {/* .col */}
                        </div> {/* .row */}
                    </DialogInput>
                </div> 
        );
    }
}


export default PaymentInfo;